import { render, staticRenderFns } from "./live.vue?vue&type=template&id=1e8efc1b&scoped=true&"
import script from "./live.vue?vue&type=script&lang=ts&"
export * from "./live.vue?vue&type=script&lang=ts&"
import style0 from "./live.vue?vue&type=style&index=0&id=1e8efc1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8efc1b",
  null
  
)

export default component.exports